import { useContext } from 'react';
import { authContext } from '../context';

export const useAuthContext = () => {
  const context = useContext(authContext);
  if (!context) {
    throw new Error('useAuthContext must be used inside authProvider');
  }

  return context;
};
